var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { startOfToday } from 'date-fns';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { AptiveIcon, Tabs, Tab, Progress } from '@aptive-env/storybook';
import { Card } from '@aptive-env/storybook';
import MiniCalendar from 'components/shared/MiniCalendar';
import { OfficeModal } from 'components/OfficeModal';
import Popover from 'components/shared/Popover';
import { RouteLayersPopoverContent } from 'components/RouteLayersPopoverContent';
import { RouteLayersToggleButton } from 'components/RouteLayersToggleButton';
import { MapTypeChangeButton } from 'components/MapTypeChangeButton';
import { MapTypePopoverContent } from 'components/MapTypePopoverContent';
import Map from 'components/Map';
import { Route, Stats as StatsIcon } from 'icons';
import Stats from 'components/Stats';
import Routes from 'components/Routes';
import styles from './index.module.scss';
import { fetchFleetRoutes, fetchRegions } from 'services/track';
import { fetchUserAvatar } from 'services/calendar';
import { mockupRegions } from 'constants/mockup';
import { EMapType } from 'interface/map';
import { socket } from 'services/socket';
import { MapZoomControl } from 'components/MapZoomControl';
import { calculateTimeLeft } from 'utils/countdownTimer';
import { createContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
export var AppContext = createContext({
    isGoogleMapAPILoaded: false,
    googleMapAPILoadError: undefined,
});
var libraries = ['drawing', 'places'];
var MapView = function () {
    var _a, _b;
    var today = startOfToday(); // TODO update day from api
    var _c = useState(), fleetRoutes = _c[0], setFleetRoutes = _c[1];
    var _d = useState(today), currentDate = _d[0], setCurrentDate = _d[1];
    var _e = useState([]), regions = _e[0], setRegions = _e[1];
    var _f = useState(mockupRegions.result[0].offices[0]), selectedOffice = _f[0], setSelectedOffice = _f[1];
    var _g = useState(['homes', 'routes', 'route-polygon', 'service-pro', 'service-vehicles']), routeLayers = _g[0], setRouteLayers = _g[1];
    var _h = useState(false), isRouteLayersPopoverOpen = _h[0], setIsRouteLayersPopoverOpen = _h[1];
    var _j = useState(false), isOfficeModalOpen = _j[0], setIsOfficeModalOpen = _j[1];
    var _k = useState(mockupRegions.result[0].offices[0].location), mapCenter = _k[0], setMapCenter = _k[1];
    var _l = useState(false), isMapTypePopoverOpen = _l[0], setIsMapTypePopoverOpen = _l[1];
    var _m = useState(EMapType.TRAFFIC), mapType = _m[0], setMapType = _m[1];
    var _o = useState(11), mapZoom = _o[0], setMapZoom = _o[1];
    var _p = useState(calculateTimeLeft(currentDate, (_a = selectedOffice.timezone) === null || _a === void 0 ? void 0 : _a.timezone)), timeLeft = _p[0], setTimeLeft = _p[1];
    var _q = useJsApiLoader({
        googleMapsApiKey: (_b = process.env.REACT_APP_GOOGLE_MAPS_API_KEY) !== null && _b !== void 0 ? _b : '',
        libraries: libraries,
    }), isLoaded = _q.isLoaded, loadError = _q.loadError;
    var isRoutesStarted = useMemo(function () {
        return timeLeft === '';
    }, [timeLeft]);
    useEffect(function () {
        var timer = setInterval(function () {
            var _a;
            setTimeLeft(calculateTimeLeft(currentDate, (_a = selectedOffice.timezone) === null || _a === void 0 ? void 0 : _a.timezone));
        }, 1000);
        return function () { return clearInterval(timer); };
    }, [currentDate, selectedOffice]);
    useEffect(function () {
        fetchFleetRoutes(selectedOffice.id, currentDate)
            .then(function (routers) { return __awaiter(void 0, void 0, void 0, function () {
            var promises;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = [];
                        routers === null || routers === void 0 ? void 0 : routers.routes.forEach(function (route) {
                            promises.push(fetchUserAvatar(route.external_id));
                        });
                        return [4 /*yield*/, Promise.all(promises)
                                .then(function (avatars) {
                                routers === null || routers === void 0 ? void 0 : routers.routes.forEach(function (route, index) {
                                    var _a;
                                    route.avatar = ((_a = avatars[index]) === null || _a === void 0 ? void 0 : _a._metadata.success) ? avatars[index].result.avatarBase64 : undefined;
                                });
                            })
                                .catch(function (error) { return console.log(error); })];
                    case 1:
                        _a.sent();
                        setFleetRoutes(routers);
                        return [2 /*return*/];
                }
            });
        }); });
        socket.on('connect', function () {
            console.log('Connected');
            // Request to join a room
            socket.emit('join', 'aro-service');
            console.log('Joined to room: aro-service');
        });
        socket.on('disconnect', function () {
            console.log('Disconnected');
        });
        socket.on('connect_error', function () {
            console.log('Connection Error');
            console.log('Attempting reconnect...');
            setTimeout(function () {
                socket.connect();
            }, 1000);
        });
        socket.on("track-office-".concat(selectedOffice.id), function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var data = args[0];
            console.log('Event Received:', 'aro-service', "tracking-office-".concat(selectedOffice.id), data);
            // Update the map with the new data
            var tempFleetRoutes = __assign({}, fleetRoutes);
            tempFleetRoutes['routes'].forEach(function (route) {
                data['routes'].forEach(function (newRoute) {
                    if (route.id === newRoute.id) {
                        route.actual_stats = newRoute.actual_stats;
                        route.tracking_data = newRoute.tracking_data;
                        route.statistics = newRoute.statistics;
                    }
                });
            });
            tempFleetRoutes['summary'] = data['summary'];
            setFleetRoutes(tempFleetRoutes);
        });
        return function () {
            socket.off('connect_error');
            socket.off('connect');
            socket.off('disconnect');
            socket.off("track-office-".concat(selectedOffice.id));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentDate, selectedOffice]);
    useEffect(function () {
        fetchRegions().then(function (regions) {
            setRegions(regions);
        });
    }, []);
    var handleDateChange = useCallback(function (date) { return setCurrentDate(date); }, []);
    var openOfficeSelectionModal = function () {
        setIsOfficeModalOpen(true);
    };
    var closeOfficeSelectionModal = function () {
        setIsOfficeModalOpen(false);
    };
    var handleClickRouteLayersToggleButton = function () {
        setIsMapTypePopoverOpen(false);
        setIsRouteLayersPopoverOpen(function (prevOpen) { return !prevOpen; });
    };
    var toggleRouteLayer = function (layer) {
        if (routeLayers.includes(layer)) {
            setRouteLayers(routeLayers.filter(function (item) { return item !== layer; }));
        }
        else {
            setRouteLayers(__spreadArray(__spreadArray([], routeLayers, true), [layer], false));
        }
    };
    var handleChangeOffice = function (office) {
        setSelectedOffice(office);
        closeOfficeSelectionModal();
        setMapCenter(office.location);
    };
    var handleClickMapTypeChangeButton = (function () {
        setIsRouteLayersPopoverOpen(false);
        setIsMapTypePopoverOpen(!isMapTypePopoverOpen);
    });
    var handleChangeMapType = function (type) {
        setMapType(type);
        setIsMapTypePopoverOpen(false);
    };
    var handleZoom = function (type) {
        if (type === 'in') {
            setMapZoom(mapZoom + 1);
        }
        if (type === 'out' && mapZoom > 0) {
            setMapZoom(mapZoom - 1);
        }
    };
    var _r = useState(0), currentTab = _r[0], setCurrentTab = _r[1];
    return (_jsx(AppContext.Provider, __assign({ value: { isGoogleMapAPILoaded: isLoaded, googleMapAPILoadError: loadError } }, { children: _jsxs("div", __assign({ className: "grow flex relative px-[32px] py-[24px]" }, { children: [_jsx("div", __assign({ className: "h-[calc(100%-48px)] absolute z-10" }, { children: _jsxs(Card, __assign({ className: "h-[calc(100%-34px)] min-w-[375px] bg-ui-snow mx-[15px] my-[17px] rounded-lg shadow-med flex flex-col" }, { children: [_jsx(MiniCalendar, { className: "bg-white border-b border-ui-gray-100 rounded-t-lg", currentDate: currentDate, view: "week", onChange: handleDateChange }), _jsxs("div", __assign({ className: "pl-[24px] pr-[8px] py-[16px] bg-ui-gray-50 border-b border-ui-gray-100 text-ui-gray-600 flex items-center justify-between" }, { children: [_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsxs("div", __assign({ className: "text-small mb-2" }, { children: ["Office: ", _jsxs("span", { children: [selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.region, " /"] })] })), _jsx("div", __assign({ className: "text-bodyBold font-bold" }, { children: selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.name }))] })), _jsxs("div", __assign({ className: "flex items-center justify-center w-[64px] h-[40px] cursor-pointer", onClick: openOfficeSelectionModal }, { children: [_jsx(AptiveIcon, { className: "w-[24px] h-[24px] stroke-ui-gray-600 fill-none", icon: "globeAlt" }), _jsxs("div", __assign({ className: "w-[24px] h-[24px] flex flex-col items-center" }, { children: [_jsx(AptiveIcon, { className: "w-[16px] h-[14px] stroke-ui-gray-600 fill-none", icon: "chevronUp" }), _jsx(AptiveIcon, { className: "w-[16px] h-[14px] stroke-ui-gray-600 fill-none", icon: "chevronDown" })] }))] }))] })), !isRoutesStarted && (_jsxs("div", __assign({ className: "h-[62px] flex-none px-6 bg-ui-gray-200" }, { children: [_jsx("div", __assign({ className: "text-[14px] font-normal mt-3 text-text-default" }, { children: "Routes start in:" })), _jsx(Progress, { className: "bg-white mt-[4px] [&>.progresslabel]:top-[-20px] [&>.progressvalue]:h-[10px]", value: timeLeft })] }))), _jsx(OfficeModal, { open: isOfficeModalOpen, className: "w-[658px] min-h-599", selectedOffice: selectedOffice, regions: regions, onSelectOffice: function (office) { return handleChangeOffice(office); }, onClose: closeOfficeSelectionModal, center: selectedOffice.location }), _jsxs("div", __assign({ className: "".concat(isRoutesStarted ? 'h-[calc(100%-201px)]' : 'h-[calc(100%-201px-62px)]', " flex flex-col p-4 gap-4") }, { children: [_jsxs(Tabs, __assign({ className: "p-1 pb-[3px] border-b border-[#E0E3E8]", value: currentTab, onChange: setCurrentTab }, { children: [_jsxs(Tab, __assign({ className: "h-[40px] flex flex-1 justify-center items-center gap-2 ".concat(currentTab === 0 ? styles.activeTab : ''), value: 0 }, { children: [_jsx(Route, { className: "".concat(currentTab === 0 ? styles.activeSvg : '') }), _jsx("span", __assign({ className: "font-inter font-bold text-xs" }, { children: "Routes" }))] })), _jsxs(Tab, __assign({ className: "h-[40px] flex flex-1 justify-center items-center gap-2 ".concat(currentTab === 1 ? styles.activeTab : ''), value: 1 }, { children: [_jsx(StatsIcon, { className: "".concat(currentTab === 1 ? styles.activeSvg : '') }), _jsx("span", __assign({ className: "font-inter font-bold text-xs" }, { children: "Stats" }))] }))] })), fleetRoutes && (currentTab === 0
                                        ? _jsx(Routes, { items: fleetRoutes['routes'], isStarted: isRoutesStarted })
                                        : _jsx(Stats, { items: fleetRoutes['summary'] }))] }))] })) })), _jsx("div", __assign({ className: "absolute z-10 right-[32px] mx-[15px] my-[17px]" }, { children: _jsx(Popover, __assign({ open: isRouteLayersPopoverOpen, position: "left", content: _jsx(RouteLayersPopoverContent, { routeLayers: routeLayers, onClickClose: function () { return setIsRouteLayersPopoverOpen(false); }, onClickOption: toggleRouteLayer }), onClickOutside: function () { return setIsRouteLayersPopoverOpen(false); } }, { children: _jsx(RouteLayersToggleButton, { onClick: handleClickRouteLayersToggleButton }) })) })), _jsx("div", __assign({ className: "absolute z-10 right-[32px] top-[112px] mx-[15px] my-[17px]" }, { children: _jsx(Popover, __assign({ open: isMapTypePopoverOpen, position: "left", content: _jsx(MapTypePopoverContent, { type: mapType, onChangeType: handleChangeMapType }), onClickOutside: function () { return setIsMapTypePopoverOpen(false); } }, { children: _jsx(MapTypeChangeButton, { type: mapType, onClick: handleClickMapTypeChangeButton }) })) })), _jsx("div", __assign({ className: "absolute z-10 right-[54px] top-[208px] mx-[15px] my-[17px]" }, { children: _jsx(MapZoomControl, { onZoom: handleZoom }) })), _jsx(Map, { mapType: mapType, mapData: fleetRoutes, routeLayers: routeLayers, center: mapCenter, zoom: mapZoom })] })) })));
};
export default MapView;
